<template>
  <div>
    <HeaderNavHomepage />
    <!-- <PricingHeaderCC /> -->
    <!-- <ForContentCreators /> -->
    <!-- <ExpandDetailsCC /> -->

    <section>
      <div class="main-title">
        <h1>Enable millions in revenue, <span>keep 90%</span></h1>

        <p>Custom website, digital payments & full suite ticketing solution</p>

        <p>
          Start for free in 1 day. No sign-up fees, lock-ins, fixed fees, or any
          others costs.
        </p>

        <div class="percentage-box">
          <p style="opacity: 0.5">Simple revenue-share model</p>

          <img src="/img/percentage-bar.png" class="main-img-mobile" alt="" />

          <p>Includes all HelixPay features & payments methods 🎉</p>
        </div>
      </div>
    </section>

    <MainFooter />

    <MessengerFAB />
  </div>
</template>

<script>
import HeaderNavHomepage from '@/components/HeaderNavHomepage.vue';
import MainFooter from '@/components/MainFooter.vue';
import MessengerFAB from '@/components/MessengerFAB.vue';
import { buildPageMeta } from '@/utils/meta';
import { useHead } from '@vueuse/head';

export default {
  components: {
    HeaderNavHomepage,
    MainFooter,
    MessengerFAB,
  },

  setup() {
    useHead(
      buildPageMeta({
        title: 'Pricing | Ecommerce Technology for Creators & Communities',
        description:
          'Select option that is the best fit for your business needs. HelixPay Checkout is custom built for subscriptions and recurring payments.',
        url: 'https://www.helixpay.ph/pricing',
        image: 'https://www.helixpay.ph/img/Website-Illustration.png',
      })
    );
  },
};
</script>

<style scoped>
section {
  background-color: black;
}

.main-title {
  text-align: center;
  max-width: 71rem;
  padding: 8rem 2rem;
  margin: auto;
}

.main-title > h1 {
  color: white;
  font-size: 3rem;
  font-weight: 700;
}

span {
  color: #ff5f8f;
}

.main-title > p {
  color: white;
  font-size: 1.5rem;
  font-weight: 500;
}

.percentage-box {
  display: grid;
  gap: 1rem;
  padding: 4rem 2rem;
  background-color: white;
  max-width: 35rem;
  margin: auto;
  margin-top: 4rem;
  border-radius: 10px;
}

.percentage-box p {
  font-weight: 700;
}

.percentage-box img {
  width: 100%;
}

@media only screen and (max-width: 900px) {
  .main-title > h1 {
    font-size: 2rem;
  }

  .main-title > h4 {
    font-size: 1rem;
  }

  .main-title > p {
    font-size: 1rem;
  }
}
</style>
